import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Hero } from '../components/home/Hero';
import { Principles } from '../components/home/Principles';
import { Steps } from '../components/home/Steps';
import { Transparency } from '../components/home/Transparency';
import { LabsPreview } from '../components/home/LabsPreview';
import { PharmacyPreview } from '../components/home/PharmacyPreview';
import { Testimonial } from '../components/home/Testimonial';
import { ProgramTable } from '../components/programs/ProgramTable';
import { SectionHeading } from '../components/ui/SectionHeading';
import { FaqList } from '../components/ui/FaqList';
import { CtaBand } from '../components/ui/CtaBand';
import { programs } from '../data/programs';
import { faqs } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
export function Home() {
  const {
    brand
  } = useBrand();
  useDocumentMeta({
    title: brand.copy.metaTitle,
    description: brand.copy.metaDescription
  });
  return <main data-id="element-355" data-mp="2vx6rqagphx4x">
      <Hero data-id="element-356" data-mp="2vxf503gqr4gn" />

      <section className="bg-cream-light" data-id="element-357" data-mp="2vyzzxu6ywpf1">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-358" data-mp="2vvvp4dyzyvfe">
          <div className="flex flex-wrap items-end justify-between gap-8" data-id="element-359" data-mp="2qwshqmvjod49">
            <SectionHeading eyebrow="Programs" title="Six programs. One clinical standard." intro="Each program is a written protocol, a named pharmacy and a published price — not a catalogue of products." data-id="element-360" data-mp="2mw8k7i7277hl" />
            <Link to="/programs" className="group inline-flex items-center gap-2 pb-2 text-sm text-ink transition-colors duration-150 ease-republic hover:text-brick" data-id="element-361" data-mp="287ujpdx47v47">
              All programs
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-362" data-mp="1z64gzbxs99r4" />
            </Link>
          </div>
          <ProgramTable items={programs} data-id="element-363" data-mp="1kkz0h8gknlq7" />
        </div>
      </section>

      <Principles data-id="element-364" data-mp="1kmtmkq3kxjvv" />
      <Steps data-id="element-365" data-mp="1omc91qb1u30t" />
      <Transparency data-id="element-366" data-mp="1omu088iutr1v" />
      <PharmacyPreview data-id="element-367" data-mp="1ondi5p8i8ffw" />
      <LabsPreview data-id="element-368" data-mp="1onvl14po9rws" />
      <Testimonial data-id="element-369" data-mp="1ojzg6i3r688z" />

      <section className="bg-cream" data-id="element-370" data-mp="1amt1aym5gtp1">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-371" data-mp="1anumvx0skyl0">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-372" data-mp="1fl4cbco6la8u">
            <SectionHeading eyebrow="Questions" title="Answered plainly." data-id="element-373" data-mp="23b8fxk1dd9zu" />
            <FaqList items={faqs} data-id="element-374" data-mp="23dbbskp7dxch" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-375" data-mp="289s2nmnsept9" />
    </main>;
}